// import {Debugger} from 'dashboard-js/providers/DebuggingProvider'
import ChannelProvider from 'dashboard-js/providers/ChannelProvider'
import ChatProvider from 'dashboard-js/providers/ChatProvider'
import NavigationProvider from 'dashboard-js/providers/NavigationProvider'
import NotificationProvider from 'dashboard-js/providers/NotificationProvider'
import Spark from './spark'
import UserProvider from 'dashboard-js/providers/UserProvider'

require('./bootstrap')

// Start providers
if (UserProvider.authUser()) {
    UserProvider.start()
    ChannelProvider.start()

    if (window.Spark.client === 'web') {
        ChatProvider.start()
        NotificationProvider.start()
    }
}

// Start turbolinks
NavigationProvider.start()

document.addEventListener('turbolinks:load', () => {
    window.Bus = new Vue()

    new Vue({
        mixins: [Spark],
    })
})
